import React from 'react';

import '../../shared/feedback/aviso-de-tela.css';

interface Props {
  /** Quando o rascunho foi guardado pela última vez (ISO), como o servidor devolveu. */
  atualizadoEm: string | null;
  /** Ausente quando recomeçar não é possível (ex.: o checklist já foi salvo e só faltam as mídias). */
  onComecarDoZero?: () => void;
}

/**
 * Faixa "rascunho restaurado" (oficina/at-136), compartilhada pelo cadastro de veículo e pelo
 * checklist. Diz que o formulário NÃO abriu vazio por acaso e oferece começar do zero — sem isso,
 * quem não sabe do rascunho acharia que o sistema preencheu sozinho.
 */
const RascunhoRestaurado: React.FC<Props> = ({ atualizadoEm, onComecarDoZero }) => {
  const quando = atualizadoEm
    ? new Date(atualizadoEm).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
    : null;
  return (
    <div className="aviso-de-tela" role="status" style={{ width: '100%', marginBottom: 12 }}>
      O que você estava preenchendo foi recuperado{quando ? ` (guardado em ${quando})` : ''}.{' '}
      {onComecarDoZero && (
        <button type="button" className="aviso-de-tela-link" onClick={onComecarDoZero}>
          Começar do zero
        </button>
      )}
    </div>
  );
};

export default RascunhoRestaurado;
